import React from 'react'
import { IIntakeStep } from './IIntakeStep'
import { IntakeStepButton } from './IntakeStepButton'
import { ANSWER_INDEX, ReviewStepRadioButtons } from './ReviewStepRadioButtons'

/* tslint:disable */
export const review3Steps: IIntakeStep[] = [
  {
    Component: IntakeStepButton, buttonLabel: 'Start', children: <div>
    In order to ensure that the WebTIPS site is effective in teaching you everything you need to know about preparing for your child's surgery, we'd like to ask you a few questions about the section you just read. Just click the answer you think is correct!
      <br /><br />
    Once you've answered the questions, you'll be able to move on to the next section.
    </div>, completed: intake => !!intake.review3CheckedDescribeText,
    label: 'Recovery Room review',
    name: 'review3CheckedDescribeText',
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review3TrueAboutRecoveryRoomExcept,
    label: 'All the following is true about the recovery room except: ',
    correctText: 'Right answer. All other statements are true.',
    wrongText: 'The correct answer was D. All other statements are true.',
    crossOutIndexes: [
      ANSWER_INDEX.D,
    ],
    name: 'review3TrueAboutRecoveryRoomExcept', options: [{
      correct: false,
      label: 'A: It is also called the PACU and the wake up room',
      value: 'PACU',
    }, {
      correct: false,
      label: 'B: Some children may be upset and crying as they wake up in the recovery room',
      value: 'upsetCrying',
    }, {
      correct: false,
      label: 'C: It can be a noisy, busy place',
      value: 'noisyBusy',
    }, {
      correct: true,
      label: 'D: It is where you recover your child’s belongings after surgery',
      value: 'recoverBelongings',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review3ChildsPainManagedInRecoveryRoom,
    correctText: 'Right answer.',
    wrongText: 'The correct answer was A.',
    crossOutIndexes: [
      ANSWER_INDEX.B,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    label: 'One of the ways your child’s pain is managed in the recovery room is: ',
    name: 'review3ChildsPainManagedInRecoveryRoom', options: [{
      correct: true,
      label: 'A: Giving your child medications through their IV',
      value: 'medsThroughIV',
    }, {
      correct: false,
      label: 'B: All children receive pain medication regardless of how much pain they are in',
      value: 'allPainMedication',
    }, {
      correct: false,
      label: 'C: Pain will be the same in all children no matter the surgery',
      value: 'painSame',
    }, {
      correct: false,
      label: 'D: It is best to ignore your child’s pain in the recovery room',
      value: 'ignorePain',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review3DistractionGoodTechniqueRecoveryRoom,
    correctText: 'Right answer.',
    wrongText: 'The correct answer was A.',
    crossOutIndexes: [
      ANSWER_INDEX.B,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    label: 'Distraction is also a good technique to use with your child in the recovery room. ',
    name: 'review3DistractionGoodTechniqueRecoveryRoom', options: [{
      correct: true,
      label: 'A: True',
      value: 'true',
    }, {
      correct: false,
      label: 'B: False',
      value: 'false',
    }],
  },
	{
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review3AllWaysHelpChildInRecoveryRoomExcept,
    label: 'All the following are ways parents can help their child in the recovery room except: ',
    correctText: 'Right answer. All other statements are true.',
    wrongText: 'The correct answer was C. All other statements are true.',
    crossOutIndexes: [
      ANSWER_INDEX.C,
    ],
    name: 'review3AllWaysHelpChildInRecoveryRoomExcept', options: [{
      correct: false,
      label: 'A: Talk with your child about outside events/activities',
      value: 'outsideEvents',
    }, {
      correct: false,
      label: 'B: Offer to play a game or watch a movie with your child',
      value: 'playGameWatchMovie',
    }, {
      correct: true,
      label: 'C: Give your child as much reassurance as possible',
      value: 'reassurance',
    }, {
      correct: false,
      label: 'D: Have your child tell you about their favorite superhero, movie, or cartoon',
      value: 'favoriteSuperheroMovieCartoon',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review3SomeChildrenStillAsleepRecoveryRoom,
    label: 'Some children are still asleep when they are brought to the recovery after surgery. ',
    correctText: 'Right answer.',
    wrongText: 'The correct answer was A.',
    crossOutIndexes: [
      ANSWER_INDEX.B,
    ],
    name: 'review3SomeChildrenStillAsleepRecoveryRoom', options: [{
      correct: true,
      label: 'A: True',
      value: 'true',
    }, {
      correct: false,
      label: 'B: False',
      value: 'false',
    }],
  },
]



// WEBPACK FOOTER //
// ./src/organisms/Intakes/review3Steps.tsx